import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';

import {
  FOOTBALL_CLUBS_SLUG_FIXTURES,
  FOOTBALL_LEAGUES_SLUG_FIXTURES,
} from 'constants/__generated__/routes';

const IGNORED_ROUTES = [
  FOOTBALL_CLUBS_SLUG_FIXTURES,
  FOOTBALL_LEAGUES_SLUG_FIXTURES,
];

export const EnsureTopVisibleOnMount = ({
  children,
  behavior = 'smooth',
}: {
  children: ReactNode;
  behavior?: ScrollBehavior;
}) => {
  const location = useLocation();

  useEffect(() => {
    if (!IGNORED_ROUTES.some(route => matchPath(route, location.pathname))) {
      window.scrollTo({ top: 0, behavior });
    }
  }, [behavior, location.pathname]);

  return <div>{children}</div>;
};
